import { SelectedMethodInfo } from '../BulkEditModal';

export const isInternationalMethod = (method: SelectedMethodInfo): boolean => {
  const category = method.shippingMethodCategory?.toLowerCase() || '';
  return category.includes('international');
};
